






















































































import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import {
    getBoundsFromPosition,
    getContentInfoVehicleInsurance,
    getRandom,
    initMapCenter,
    mouseoutEvent,
    mouseoverEvent
} from './Map/index';
import MapLoader from './Map/MapLoader.vue';
import Loading from 'vue-loading-overlay';
import {
    formatDate,
    EventBus,
    TypeEventBus,
    getUniqueId,
    trackingColors,
    MarkerGoogleMapInfo,
    getRandomColor,
    insuranceColors,
    segmentsColors,
    getCoordinatesFromFeature,
    isRightClickOnVertex,
    removeVertexFromFeature,
    getNewFeatureGeometryWithNewPolygons,
    extendBoundsPolygon,
    getExtendedBoundsFromFeature,
    parseGeoJsonToGoogleMapsGeometry,
    convertCoordinatesToLatLng,
    customPinElement,
} from '../../core/utils';
import { Destroyed } from '../decorators';
import { LatLng, LatLngBounds } from 'spherical-geometry-js';
import { select } from '../operators';
import ContextMenu from './ContextMenu.vue';
import ToggleCalibrationsPassesMap from '../../insurance/components/ToggleCalibrationsPassesMap.vue';
import AddPolygon from './AddPolygon.vue';
import { forEach } from 'jszip';
import ModalSmartRoute from '../../insurance/components/ModalSmartRoute.vue';
import { VehicleCompanyStoreHelper, NotificationStoreHelper } from '../mixins';
import { CalibrationsPassesGeojson, CalibrationsPassesMap, Marker, Point } from '../models';
import { attachMarkerListeners, getInfoWindow } from '../../tracking/map-markers-infos';


@Component({
    components: {
        MapLoader,
        Loading,
        ContextMenu,
        AddPolygon,
        ToggleCalibrationsPassesMap,
        ModalSmartRoute
    }
})

export default class SimpleMap extends Mixins(NotificationStoreHelper, VehicleCompanyStoreHelper) {
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: false }) savingSmartRoute: boolean;
    @Prop({ default: false }) splitRanchs: boolean;
    @Prop({ default: false }) removeRanch: boolean;
    @Prop({ default: false }) showExpansionPanel: boolean;
    @Prop({ default: false }) visibleRightPanel: boolean;
    @Prop({ default: false }) visibleExpandible: boolean;
    @Prop({ default: false }) showBottomPanel: boolean;
    @Prop({ default: false }) placeMarker: boolean;
    @Prop({ default: 'roadmap' }) mapTypeId: boolean;
    @Prop({ default: '500px' }) mapHeight: string;
    @Prop({default: true}) disableSeeInNewTab: boolean;
    visibilityExpandible: boolean = false;
    visiblePolylines: Array<google.maps.Polyline> = [];
    visibleGroundOverlays: Array<google.maps.GroundOverlay> = [];
    visibleHumidityCircles: Array<google.maps.Circle> = [];
    visibleSegmentsOfWork: Array<google.maps.Polyline> = [];
    geojsonTravel: google.maps.Data | null = null;
    geojsonSegmentsOfWork: google.maps.Data | null = null;
    geojsonCalibrationPasses: google.maps.Data | null = null;
    allCalibrationsPasses: google.maps.Data | null = null;
    initZoom: number = 7;
    mapConfig: any = {
        zoom: this.initZoom,
        center: initMapCenter,
        mapTypeId: this.getMapType,
        mapId: 'INSURANCE_MAP',
    };
    showCalibrationsPassesToggle: boolean = false;
    //ctrl mac listeners
    showCropType: boolean = false;
    isMac: boolean = false;
    webkit: boolean = false;
    mozilla: boolean = false;
    opera: boolean = false;
    kC: string = '';
    selectingRanchs: boolean = false;
    listenerEditPolygon: any = null;
    editPolygon: boolean = false;
    ranchsSelected: Array<object> = [];
    markersPositions: Array<object> = [];
    activeInfoWindows: any = [];
    colorGreen: string = '#0096cc';
    defaultPolygonStyles: object = {
        fillColor: '#adb3e6',
        strokeColor: '#000000',
        strokeWeight: 1.5
    };
    mouseOverPolygonStyles: object = {
        strokeWeight: 2,
        fillColor: '#42a6e2'
    };
    multiplePolygonsSelectedStyles: object = {
        strokeWeight: 1,
        fillColor: this.colorGreen
    };
    unselectedPolylineOptions: object = {
        strokeOpacity: 0.2
    };
    selectedPolylineOptions: object = {
        strokeOpacity: 1,
        fillColor: this.colorGreen,
        strokeColor: '#ffffff'
    };
    previousBounds: any = {};
    contextMenuItem: any = [];
    rightClickEvent: any = null;
    showContextMenu: boolean = true;
    featureIdToIntersect: number = -1;
    visibleAddPolygon: boolean = false;
    polyCoords: any = [];
    savedPolygonsOnMemory: Array<google.maps.Polygon> = [];
    previousEditableFeature: google.maps.Data.Feature | null = null;
    previousFeatureCoords: {
        coords: google.maps.Data.Geometry | null
    } = {
        coords: null
    };
    currentPoly: Array<google.maps.Polygon>  = [];
    drawingManager: any = null;
    markerAdded: google.maps.marker.AdvancedMarkerElement | null = null;
    selectedRanchs: Array<google.maps.Data.Feature> = [];
    markersInfoWindows: any = [];
    featuresGeojsonToExport: any = [];
    maxLimitOfPointsToShow: number = 12000;
    lastGeojsonAdded: object | null = null;
    doNotTriggerTwiceEvt: any = null;
    newAddedPolygonId: string = '';
    visibleModalSmartRoute: boolean = false;
    smartRouteStartPoint: google.maps.LatLng | null = null;
    visibleMarkers: Array<google.maps.marker.AdvancedMarkerElement> = [];
    doNotTriggerTwiceTimeout: any = null;

    closeModalSmartRoute() {
        this.visibleModalSmartRoute = false;

    }

    @Emit()
    cancelSmartRoute() {
        this.smartRouteStartPoint = null;
        this.closeModalSmartRoute();
    }

    toggleModalSmartRoute(value: boolean) {
        this.visibleModalSmartRoute = value;
    }


    @Emit()
    intersectRanch(featureId: number, coords: Array<google.maps.LatLng>, polyName: string) {}

    @Emit()
    polylineClicked(feature: google.maps.Data.Feature) {}

    clickAddNewPolygon(){
        this.enableMapDrawingTools();
    }

    @Emit()
    modifyRanchPolygon(
        name: string, 
        cropTypeSelected: object | null, 
        coords: google.maps.LatLngLiteral[][][][],
        type: string,
        previousFeature: google.maps.Data.Feature | null
    ) {

    }

    modifyRanchEvt(feature: google.maps.Data.Feature) {
        this.savePreviousEditableFeature(feature);
        this.showCropType = true;
        this.editPolygon = true;
        this.visibilityAddPolygonModal(true);
        this.$emit('modify-ranch', feature);
        EventBus.$emit(TypeEventBus.MODIFY_RANCH_FROM_MAP, feature);
    }


    @Emit()
    seeInNewTab(feature: google.maps.Data.Feature) {
        
    }

    closeContextMenu() {
        this.showContextMenu = false;
    }

    get watchRightClickEvent() {
        return this.rightClickEvent;
    }

    get getMapType() {
        return this.mapTypeId;
    }

    get existsSelectedRanchs() {
        return this.selectedRanchs.length > 0 ? true : false;
    }

    addMapListeners() {
        let self = this;
        // console.log("addMapListeners", this.googleMap);

        if (this.placeMarker) {
            setTimeout(() => {
                google.maps.event.addListener(self.googleMap, 'click', function(e) {
                    self.placeMarkerOnMap(e.latLng);
                });
            }, 500);
        }
    }

    placeMarkerOnMap(location: google.maps.LatLng) {
        if (this.markerAdded !== null) {
            this.markerAdded.position = location;
        } else {
            this.markerAdded = new google.maps.marker.AdvancedMarkerElement({
                position: location,
                map: this.googleMap
            });
        }
        this.$emit('added-marker', {
            lat: location.lat(),
            lng: location.lng()
        });
    }

    addDragListener() {
        google.maps.event.addListener(this.googleMap, 'drag', function(event) {
            alert('drag');
        });
    }

    sayWho() {
        let ua = navigator.userAgent,
            tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { browser: 'IE', version: tem[1] || '' };
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            //if(tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            if (tem != null) return { browser: tem.slice(1)[0].replace('OPR', 'Opera'), version: tem.slice(1)[1] };
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
        return { browser: M[0], version: M[1] };
    }

    addCoordsToFeature(newPolygon: google.maps.Polygon) {
        // Extract coordinates from the new polygon
        let newCoords:google.maps.LatLng[] = [];
        let paths = newPolygon.getPaths();
        paths.forEach(path => {
            let coords = path.getArray();
            coords.forEach(coord => {
                newCoords.push(coord);
            });
        });
        let newPolygonId = getUniqueId();
    

        if(this.previousEditableFeature == null){
            let newDataPolygon = new google.maps.Data.Polygon([newCoords])
            //add google map data feature
            let newFeature = new google.maps.Data.Feature({
                geometry: newDataPolygon,
                properties: {
                    customId: newPolygonId,
                    newPolygon: true
                }
            });
            this.previousEditableFeature = newFeature;
            this.googleMap.data.add(newFeature);
            this.newAddedPolygonId = newPolygonId;
            // console.log("new polygon added");
        }else{
            // console.log("actualizo poligono existente")
            let self = this;
             let newCoordsAsPolygon = new google.maps.Polygon({
                paths: newCoords
            });
           getNewFeatureGeometryWithNewPolygons([newCoordsAsPolygon], this.previousEditableFeature);
        }
        if(this.previousEditableFeature){
            this.googleMap.data.overrideStyle(this.previousEditableFeature,{
                editable: true
            })
            // this.previousEditableFeature.toGeoJson((geojson) => {
            //     console.log("nuevo geojson", geojson);
            // })
        }
         
    }

    addCtrlListeners() {
        let self = this;
        this.webkit = this.sayWho().browser === 'Chrome' || this.sayWho().browser === 'Safari';
        this.mozilla = this.sayWho().browser === 'Firefox';
        this.opera = this.sayWho().browser === 'Opera';
        window.addEventListener('keydown', event => {
            let kC = event.keyCode;
            if (
                event.key === 'Control' ||
                ((this.webkit || this.opera) && (kC === 91 || kC === 93)) ||
                (this.mozilla && kC === 224)
            ) {
                // console.log("control pressed");
                this.selectingRanchs = true;
            }
        });

        window.addEventListener('keyup', event => {
            let kC = event.keyCode;
            if (
                event.key === 'Control' ||
                ((this.webkit || this.opera) && (kC === 91 || kC === 93)) ||
                (this.mozilla && kC === 224)
            ) {
                //    self.$emit('ranchs-selected', this.selectedRanchs);
                this.selectingRanchs = false;
                //    if(this.vehiclesSelected.length > 0){
                //         EventBus.$emit(TypeEventBus.SELECT_VEHICLES_FROM_MAP, this.vehiclesSelected);
                //         this.vehiclesSelected = [];
                //     }
            }
        });

        window.addEventListener(
            'blur',
            event => {
                this.selectingRanchs = false;
                this.ranchsSelected = [];
            },
            false
        );
    }

    get mapLoader(): HTMLFormElement {
        return this.$refs.customMap as HTMLFormElement;
    }

    get googleMap(): google.maps.Map {
        return this.mapLoader.mapObject;
    }

    visibilityAddPolygonModal(value) {
        this.visibleAddPolygon = value;
    }

    getCurrentMapZoom() {
        return this.googleMap.getZoom() as number;
    }

    addGeoJsonClickEvent() {
        let self = this;
        this.googleMap.data.addListener('click', function(evt) {
            clearTimeout(self.doNotTriggerTwiceTimeout);
            self.doNotTriggerTwiceTimeout = setTimeout(function(){
                let bounds = new google.maps.LatLngBounds();
                let featureClicked = evt.feature;
                let customIdFeature = featureClicked.getProperty('customId');
                let array = self.getPolygonsFromFeature(featureClicked);
                array.forEach(function(item, i) {
                    let coords = item.getAt(0).getArray();
                    coords.forEach(coord => {
                        bounds.extend(coord);
                    });
                });

                if (!self.selectingRanchs) {
                    self.googleMap.setCenter(bounds.getCenter());
                    self.googleMap.fitBounds(bounds);
                    self.googleMap.setZoom(self.getCurrentMapZoom() - 0.3);
                }else{
                    //if it is control pressed
                    // console.log("click control en la chacra"); 
                    let ranchIsSelected = featureClicked.getProperty('selected');
                    if(!ranchIsSelected){
                        //if ranch is not selected
                        self.addFeatureToSelectedOnes(featureClicked);
                    }else{
                        // console.log("unselect feature", featureClicked);
                        self.unselectFeature(featureClicked)
                    }
                }
            }, 100);
            
        });
    }


    editFeaturePolygon(feature: google.maps.Data.Feature) {
        this.googleMap.data.overrideStyle(feature, {
            editable: true
        });
    }


    toggleExpansionPanel(){
        this.visibilityExpandible = !this.visibilityExpandible;
    }

    addGeoJsonHoverListener(geojson?) {
        let self = this;
        //Mouse Over Polygon
        let geojsonObject = geojson ? geojson : this.googleMap.data;
        geojsonObject.addListener('mouseover', function(evt) {
            //todo
            let bounds = new google.maps.LatLngBounds();
            let tooltipName = evt.feature.getProperty('NOMBRE_LOT')
                ? evt.feature.getProperty('NOMBRE_LOT')
                : evt.feature.getProperty('name');
            let tooltipInfo = tooltipName;
            let featureIsSelected = evt.feature.getProperty('selected');

            if (!featureIsSelected) {
            //     geojsonObject.overrideStyle(evt.feature, {
            //         fillColor: self.colorGreen
            //     });
            // } else {
                geojsonObject.overrideStyle(evt.feature, self.defaultPolygonStyles);
            }
            if (tooltipInfo !== '') {
                let infowindow = self.getInfowindow(tooltipInfo);
                infowindow.setPosition(evt.latLng);
                self.activeInfoWindows.push(infowindow);
                infowindow.open(self.googleMap);
            }
        });

        //Mouse leave polygon
        geojsonObject.addListener('mouseout', function(evt) {
            let featureIsSelected = evt.feature.getProperty('selected');
            self.activeInfoWindows.forEach(info => {
                info.setMap(null);
            });
            if (featureIsSelected == false) {
                geojsonObject.overrideStyle(evt.feature, self.defaultPolygonStyles);
            }

            self.activeInfoWindows = [];
        });

        
            

        if (this.removeRanch) {
            let self = this;
            geojsonObject.addListener('rightclick', e => {
                this.rightClickEvent = null;
                this.contextMenuItem = [];
                this.contextMenuItem.push(
                    {
                        disabled: false,
                        title: 'Excluir chacra',
                        event: {
                            name: 'ranch-to-exclude',
                            data: e.feature
                        }
                    }
                );
                for (let prop in e) {
                    if (e[prop] instanceof MouseEvent) {
                        // console.log("right click", e[prop]);
                        self.rightClickEvent = e[prop];
                    }
                }
            });
        }
    }

    excludeRanch(feature: google.maps.Data.Feature) {
        let featureId = feature.getProperty('id');
        this.$emit('ranch-to-exclude', featureId);
        this.removeFeatureFromMap(feature);
    }


    getLatLngCoordsFromFeature(feature: google.maps.Data.Feature): Array<google.maps.LatLngLiteral[]> {
        
        let coordinates: Array<google.maps.LatLngLiteral[]> = [];
        let geo = feature.getGeometry() as google.maps.Data.Geometry;

        // console.log("feature geo", geo);

        if (geo.getType() === 'Polygon') {
            let coords;
            if (geo instanceof google.maps.Data.Point) {
                coords = [geo.get()];
            } else if (geo instanceof google.maps.Data.MultiPoint || geo instanceof google.maps.Data.LineString) {
                coords = geo.getArray();
            } else if (geo instanceof google.maps.Data.MultiLineString || geo instanceof google.maps.Data.Polygon) {
                coords = geo.getArray()[0].getArray();
            } else if (geo instanceof google.maps.Data.MultiPolygon) {
                coords = geo.getArray()[0].getArray()[0].getArray();
            } else {
                coords = [];
            }
            let currentCoords: Array<google.maps.LatLngLiteral> = [];
            coords.forEach(coord => {
                currentCoords.push({ lat: coord.lat(), lng: coord.lng() });
            });
            coordinates.push(currentCoords);
        } else {
            let polygons: google.maps.Data.Polygon[] = [];
            if (geo instanceof google.maps.Data.MultiPolygon) {
                polygons = geo.getArray();
            } else if (geo instanceof google.maps.Data.Polygon) {
                polygons = [geo];
            }

            polygons.forEach(polygon => {

                // console.log("polygon", polygon);
                let coords = polygon.getAt(0).getArray();

                let currentCoords: Array<google.maps.LatLngLiteral> = [];
                coords.forEach(coord => {
                    currentCoords.push({ lat: coord.lat(), lng: coord.lng() });
                });
                coordinates.push(currentCoords);
            });
        }
        


        return coordinates;
    }

    resetSelectedRanchsInMap(){
        this.selectedRanchs = [];
    }

    updateSelectedRanchs(items){
        this.selectedRanchs = items;
    }

    savePreviousEditableFeature(feature: google.maps.Data.Feature){
        // console.log("savePreviousEditableFeature", feature);
        // console.log("savePreviousEditableFeature coords:", feature.getGeometry());
        this.previousFeatureCoords = {
            coords: feature.getGeometry()
        };
        this.previousEditableFeature = feature;
    }

    modifyPolygon(feature: google.maps.Data.Feature) {
        //save previous poly coords
        let self = this;
        this.resetSelectedRanchsInMap();
        this.savePreviousEditableFeature(feature);
        this.editPolygon = true;
        this.selectedRanchs.push(feature);

        //create an editable polygon with feature's coords
        this.editFeaturePolygon(feature);

    }

    

    getCoordsFromCurrentEditablePolygon(): {
        coords: google.maps.LatLngLiteral[][][][],
        type: string
    }{
        //devuelvo las coordenadas de los poligonos que se están editando
        
        //ccoords can be a polygon or a multipolygon
        let coordinates: google.maps.LatLngLiteral[][][][] = [];
        let type = 'MultiPolygon'

        if(this.previousEditableFeature){

            let feature = this.previousEditableFeature;
            // type = feature.getGeometry().getType();
            
            coordinates = getCoordinatesFromFeature(feature);

            // console.log("feature type", type);
        }


        return {
            coords: coordinates as unknown as google.maps.LatLngLiteral[][][][],
            type: type 
        };
    }

    removeFeatureFromMap(feature: google.maps.Data.Feature) {
        this.googleMap.data.remove(feature);
    }

    setGeoJsonStyles(geojson?) {
        let self = this;
        let geojsonObject = geojson ? geojson : this.googleMap.data;
        geojsonObject.setStyle(function(feature) {
            let color = feature.getProperty('strokeColor');
            if (color) {
                self.defaultPolygonStyles['strokeColor'] = color;
            }
            return self.defaultPolygonStyles;
        });
    }

    updateFeatureVisibility(feature: google.maps.Data.Feature, visibility: boolean) {
        let bounds = new google.maps.LatLngBounds();
        let self = this;
        this.googleMap.data.overrideStyle(feature, {
            visible: visibility
        });
        //Loop over sub polygons
        let polygons = self.getPolygonsFromFeature(feature);
        polygons.forEach(function(polygon) {
            let coords = polygon.getAt(0).getArray();
            bounds = self.getBoundsFromCoordsList(coords);
        });
        if (visibility) {
            self.triggerEvent('mouseover', {
                latLng: bounds.getCenter(),
                feature: feature
            });
        } else {
            self.triggerEvent('mouseout', {
                feature: feature
            });
        }
    }

    hideFeatureInMap(feature: google.maps.Data.Feature) {
        let featureInMap = this.getFeatureById(feature['properties']['customId']);
         if (featureInMap) {
            this.googleMap.data.overrideStyle(featureInMap, {
                visible: false
            });
            featureInMap.setProperty('visible', false);
            // console.log("feature visible false")
         }
    }

    showFeatureInMap(feature: google.maps.Data.Feature) {

        let featureInMap = this.getFeatureById(feature['properties']['customId']);
        if (featureInMap) {
            this.googleMap.data.overrideStyle(featureInMap, {
                visible: true
            });
            featureInMap.setProperty('visible', true);
        }
    }

    toggleFeatureVisibility(feature: google.maps.Data.Feature) {
        let featureInMap = this.getFeatureById(feature['properties']['customId']);
        if(featureInMap){
            let isVisible = featureInMap.getProperty('visible');

            // console.log("toggleFeatureVisibility", feature);
            // console.log("isVisible", isVisible);

            this.googleMap.data.overrideStyle(featureInMap, {
                visible: !isVisible
            });
            featureInMap.setProperty('visible', !isVisible);
        }
    }

    addBoundsChangedListener() {
        let self = this;
        this.googleMap.addListener('bounds_changed', function() {
            let currentBounds = self.googleMap.getBounds();
            self.previousBounds = currentBounds;
        });
    }

    addGeoJsonRightClickListener(geojson?) {
        let self = this;
        let geojsonObject = geojson ? geojson : this.googleMap.data;
        //Right click event
        geojsonObject.addListener('rightclick', e => {
                // console.log("right click event", e);
                clearTimeout(self.doNotTriggerTwiceEvt)
                self.doNotTriggerTwiceEvt = setTimeout(function(){
                self.rightClickEvent = null;
                const clickedOnVertex = isRightClickOnVertex(e);

                if(!clickedOnVertex){
                    //muestro el menu de click derecho
                    //solo si no se clickeo en un vertice
                    //click derecho en un vertice es para borrarlo
                    self.contextMenuItem = [];
                    if (self.splitRanchs) {
                        self.contextMenuItem.push(
                            {
                                disabled: false,
                                title: 'Dividir chacra',
                                event: {
                                    name: 'divide-ranch',
                                    data: e.feature
                                },
                            }
                        );
                    }

                    let menuModifyRanch = {
                        disabled: false,
                        title: 'Modificar chacra',
                        event: {
                            name: 'modify-ranch',
                            data: e.feature
                        },
                    }
                    let menuSeeInNewTab = {
                        disabled: false,
                        title: 'Ver en nueva pestaña',
                        event: {
                            name: 'see-new-tab',
                            data: e.feature
                        },
                    }
                    if(!clickedOnVertex){
                        self.contextMenuItem.push(menuModifyRanch);
                    }
                    if(self.disableSeeInNewTab == false){
                        self.contextMenuItem.push(menuSeeInNewTab);
                    }
                    
                    
                    for (let prop in e) {
                        if (e[prop] instanceof MouseEvent) {
                            // console.log("right click", e[prop]);
                            self.rightClickEvent = e[prop];
                        }
                    }
                }

                if(clickedOnVertex){
                    removeVertexFromFeature(e);
                }
            })
        });
    }

    

    addGeoJson(geoJson) {
        let self = this;

        // console.log("this.googleMap.data", this.googleMap.data);
        if(!this.googleMap.data){
            return
        }
        this.removeGeoJsonFeatures();
        try{
            this.googleMap.data.addGeoJson(geoJson, {
                idPropertyName: 'customId'
            });
        
        
        
        this.addGeoJsonHoverListener();
        this.addGeoJsonRightClickListener();
        this.addGeoJsonClickEvent();
        this.addBoundsChangedListener();
        this.setGeoJsonStyles();
        let bounds = new google.maps.LatLngBounds();

        this.googleMap.data.forEach(function(feature: google.maps.Data.Feature) {
            bounds = getExtendedBoundsFromFeature(feature, bounds);
        });
       
        this.setCenter(bounds);
        // console.log("bounds", bounds);
        this.fitBounds(bounds);

        } catch(e){
            // console.log("add geojson error", e);
        }
    }

    addExtraGeojsonLayer(geojson: Object){
        // console.log("addExtraGeojsonLayer", geojson);
        try{
        this.googleMap.data.addGeoJson(geojson, {
            idPropertyName: 'customId'
        });
        }catch(e){
            // console.log("addExtraGeojsonLayer error", e);
        }
    }

    removeExtraGeojsonLayer(geojson: Object){
        // console.log("removeExtraGeojsonLayer", geojson);
        // this.googleMap.data.remove(geojson);
        //remove from this.gogleMap.data feature with same customId
        let self = this;
        this.googleMap.data.forEach(function(feature: google.maps.Data.Feature) {
            let customId = feature.getProperty('customId');

            let geojsonFeatures = geojson['features'];
            let indexInGeojson = geojsonFeatures.findIndex(item => item['properties']['customId'] == customId);
            if(indexInGeojson !== -1){
                self.googleMap.data.remove(feature);
            }
        });

    }

    selectFeature(selectedFeaturesInTableList) {
        //en base a una lista de chacras seleccionadas desde la tabla
        //las recorro y las voy seleccionando en el mapa
        let self = this;
        this.updateSelectedRanchs(selectedFeaturesInTableList);
        this.featuresGeojsonToExport = [];
        if (selectedFeaturesInTableList.length == 0) {
            this.resetVisualization();
        }else{
            let featuresList: Array<google.maps.Data.Feature> = [];
            let bounds = new google.maps.LatLngBounds();
            //Loop over selected features
            // console.log("selectedFeaturesInTableList", selectedFeaturesInTableList)
            // console.log("mapa - actualizo chacras seleccionadas", selectedFeaturesInTableList);
            for (let index = 0; index < selectedFeaturesInTableList.length; index++) {
                const feature = selectedFeaturesInTableList[index];
                //me quedo con el objecto feature
                
                let selectedFeature: google.maps.Data.Feature =
                    feature && feature['properties'] && feature['properties']['customId']
                        ? this.getFeatureById(feature['properties']['customId'])
                        : this.getFeatureById(feature['customId']);
                // console.log("selectedFeature", selectedFeature);
                //Loop over sub polygons
                featuresList.push(selectedFeature);
                //me quedo con los polygonos de la feature
                bounds = getExtendedBoundsFromFeature(selectedFeature, bounds);
                // console.log("selectFeature set property selected");
                selectedFeature.setProperty('selected', true);
                selectedFeature.setProperty('zIndex', 1);
                // console.log("selectFeature get property selected", selectedFeature.getProperty('selected'));
                // console.log("le cambio el estilo a la feature para seleccionada", selectedFeature);
                this.googleMap.data.overrideStyle(selectedFeature, this.selectedPolylineOptions);
                // //trigger mouseover event to show infowindow
                // self.triggerEvent('mouseover', {
                //     latLng: bounds.getCenter(),
                //     feature: selectedFeature
                // });
            }

            //adjust visualization
            if(!this.selectingRanchs){
                //solo ajusto el zoom y los bounds si no estan seleccionando chacras con control
                this.setCenter(bounds);
                this.fitBounds(bounds);
            }
            
            featuresList.forEach(feature => {
                feature.toGeoJson(function(geojson) {
                    let propertyToMatch = geojson['properties']['ranch_id'] ? 'ranch_id' : 'id';
                    let indexIdInList = self.featuresGeojsonToExport.findIndex(
                        item => item['properties'][propertyToMatch] == geojson['properties'][propertyToMatch]
                    );
                    if (indexIdInList == -1) {
                        delete geojson['id'];
                        delete geojson['properties']['customId'];
                        self.featuresGeojsonToExport.push(geojson);
                    }
                });
            });

            this.$emit('selected-features', this.featuresGeojsonToExport);
        }
    }

    addFeatureToSelectedOnes(selectedFeature: google.maps.Data.Feature){
        // console.log("addFeatureToSelectedOnes", selectedFeature);
        let self = this;
        self.googleMap.data.overrideStyle(selectedFeature, self.selectedPolylineOptions);
        selectedFeature.toGeoJson(function(geojson:any) {
            self.selectedRanchs.push(geojson);
            self.$emit('ranch-to-select', geojson);
        })
    }

    getPathArray(polygon) {
        return polygon
            .getPath()
            .getArray()
            .map(p => {
                return { lat: p.lat(), lng: p.lng() };
            });
    }

    getPolygonsFromFeature(selectedFeature) {
        return selectedFeature.getGeometry().getArray();
    }

    getFeatureById(featureId: number | string): google.maps.Data.Feature {
        return this.googleMap.data.getFeatureById(featureId) as google.maps.Data.Feature;
    }

    triggerEvent(eventName: string, data) {
        google.maps.event.trigger(this.googleMap.data, eventName, data);
    }

    unselectFeatureFromTable(featureCustomId: string){
        // console.log("des-selecciono chacra desde la tabla", featureCustomId);
        let featureToUpdate = this.getFeatureById(featureCustomId);
        this.updateFeatureProp(featureToUpdate, 'selected', false);
        this.resetFeatureStyles(featureToUpdate);
    }

    resetFeatureStyles(feature: google.maps.Data.Feature){
         this.googleMap.data.overrideStyle(feature, this.defaultPolygonStyles);
    }

    updateFeatureProp(feature: google.maps.Data.Feature, name: string, value:boolean): void{
        feature.setProperty(name, value)
    }   

    unselectFeature(feature: google.maps.Data.Feature) {
        let selectedFeature: google.maps.Data.Feature =
            feature && feature['properties'] && feature['properties']['customId']
                ? this.getFeatureById(feature['properties']['customId'])
                : feature;
        // console.log("unselectFeature selectedFeature", selectedFeature);
        // console.log("unselectFeature feature", feature);
        this.$emit('ranch-to-remove',  selectedFeature.getProperty('customId'));
        this.updateFeatureProp(selectedFeature, 'selected', false)
        this.resetFeatureStyles(selectedFeature);
    }
    

    removeFeatureFromSelectedRanchs(feature) {
        for (let index = 0; index < this.selectedRanchs.length; index++) {
            let customIdFeature = this.getFeatureById(feature.getProperty('customId'))
            const item = this.selectedRanchs[index];
            if (item && item['properties'] && item['properties']['customId']) {
                if (item['properties']['customId'] === customIdFeature) {
                    this.selectedRanchs.splice(index, 1);
                }
            }
        }
    }

    resetVisualization() {
        this.cancelEditPolygon();
        if(this.previousBounds){
            this.setCenter(this.previousBounds);
            this.fitBounds(this.previousBounds);
        }
    }

    getBoundsFromCoordsList(coords) {
        let bounds = new google.maps.LatLngBounds();
        coords.forEach(coord => {
            if (coord !== undefined) {
                bounds.extend(coord);
            }
        });
        return bounds;
    }

    addPolylines(list) {
        this.visiblePolylines = [];
        let map = this.googleMap;
        for (let index = 0; index < list.length; index++) {
            const line = list[index];
            const points = line['vehicle_data'];
            let poly = this.createPolyline(points, index, line['color']);
            this.visiblePolylines.push(poly);
            poly.setMap(map);
        }
    }

    createPolyline(points, index, customColor?, tooltip?, customId?) {
        let map = this.googleMap;
        let pointsHasItsOwnColor = !customColor ? getRandomColor() : customColor;
        let polyOptions: any = {
            path: points.map(function(d) {
                return {
                    lat: d.gps_latitude,
                    lng: d.gps_longitude
                };
            }),
            tooltip: tooltip,
            customId: customId,
            strokeColor: pointsHasItsOwnColor,
            strokeOpacity: 1,
            zIndex: 9,
            strokeWeight: 2
        };
        let polyLine: google.maps.Polyline = new google.maps.Polyline(polyOptions);
        this.addListenerPolylines(polyLine);
        return polyLine;
    }

    selectSegmentsOfWork(selectedSegments) {
        let self = this;
        if (selectedSegments.length == 0) {
            if (self.geojsonSegmentsOfWork !== null) {
                self.geojsonSegmentsOfWork.toGeoJson(function(geojson) {
                    let allFeatures = geojson['features'];
                    if (self.geojsonSegmentsOfWork) {
                        for (let i = 0; i < allFeatures.length; i++) {
                            let currentFeature = allFeatures[i];
                            let featureObject = self.geojsonSegmentsOfWork.getFeatureById(
                                currentFeature['properties']['customId']
                            ) as google.maps.Data.Feature;
                            self.geojsonSegmentsOfWork.overrideStyle(featureObject, {
                                strokeWeight: 4,
                                strokeOpacity: 1,
                                zIndex: 9
                            });
                        }
                    }
                });
            }
        } else {
            if (self.geojsonSegmentsOfWork !== null) {
                self.geojsonSegmentsOfWork.toGeoJson(function(geojson) {
                    let allMapFeatures = geojson['features'];
                    if (self.geojsonSegmentsOfWork) {
                        for (let i = 0; i < allMapFeatures.length; i++) {
                            let currentFeature = allMapFeatures[i];
                            //me fijo si el indice está en la lista de seleccionados
                            let indexInSelectedOnes = selectedSegments.findIndex(
                                item => item['customId'] === currentFeature['properties']['customId']
                            );
                            let featureToSelect: google.maps.Data.Feature = self.geojsonSegmentsOfWork.getFeatureById(
                                currentFeature['properties']['customId']
                            ) as google.maps.Data.Feature;
                            if (indexInSelectedOnes !== -1) {
                                self.geojsonSegmentsOfWork.overrideStyle(featureToSelect, {
                                    strokeOpacity: 1,
                                    strokeWeight: 4,
                                    zIndex: 9
                                });
                            } else {
                                self.geojsonSegmentsOfWork.overrideStyle(featureToSelect, {
                                    strokeOpacity: self.unselectedPolylineOptions['strokeOpacity'],
                                    zIndex: 9
                                });
                            }
                        }
                    }
                });
            }
        }
    }
    addListenerPolylines(polyLine: google.maps.Polyline) {
        let infoWindow = new google.maps.InfoWindow();
        let currentMap = this.googleMap;
        let mouseOverTimeout;
        let self = this;
        // google.maps.event.addListener(polyLine, 'click', function(e) {
        //     self.polylineClicked(polyLine);

        // });
        google.maps.event.addListener(polyLine, 'mouseover', function(e) {
            let polyHasTooltip = polyLine['tooltip'] !== '' ? polyLine['tooltip'] : '';
            mouseOverTimeout = setTimeout(() => {
                if (polyHasTooltip) {
                    infoWindow.setPosition(e.latLng);
                    infoWindow.setContent(polyLine['tooltip']);
                    infoWindow.open(currentMap);
                }
            }, 500);

            polyLine.setOptions({
                strokeWeight: 3
            });
        });
        google.maps.event.addListener(polyLine, 'mouseout', function(e) {
            if (mouseOverTimeout) {
                clearTimeout(mouseOverTimeout);
                mouseOverTimeout = null;
            }
            polyLine.setOptions({
                strokeWeight: 2
            });
            infoWindow.close();
        });
    }

    viewMultiplePolylines(list) {
        this.visibleSegmentsOfWork = [];
        let map = this.googleMap;
        for (let index = 0; index < list.length; index++) {
            const line = list[index];
            const points = line['points'];
            const currentTooltip = line['tooltip'];
            const currentCustomId = line['customId'];

            let poly = this.createPolyline(points, index, line['color'], currentTooltip, currentCustomId);
            this.visibleSegmentsOfWork.push(poly);
            poly.setMap(map);
        }
    }

    createCircle(point, scales) {
        let map = this.googleMap;
        let self = this;
        let radius = point['work_width'] / 2;
        let bounds = new google.maps.LatLngBounds();
        let position = new google.maps.LatLng(point['lat'], point['lng']);
        bounds.extend(position);

        let circle = new google.maps.Circle({
            strokeOpacity: 0,
            strokeWeight: 0,
            fillColor: self.getColorFromValue(point['performance'], scales),
            fillOpacity: 0.85,
            center: bounds.getCenter(),
            radius: radius
        });

        return circle;
    }

    getColorFromValue(value, scales) {
        let colors = [
            '#df1e36', //10
            '#db5c6c', //9,
            '#db7d6c', //8
            '#db9d6c', //7
            '#ecbc59', //6
            '#f9e863', //5
            '#e9f063', //4
            '#c8e063', //3
            '#a7cf63', //2
            '#87bf63', //1
            '#66af63' //0
        ];

        if (value == scales[0]) {
            return colors[0];
        } else if (value == scales[1]) {
            return colors[1];
        } else if (value > scales[1] && value < scales[2]) {
            return colors[2];
        } else if (value >= scales[2] && value < scales[3]) {
            return colors[3];
        } else if (value >= scales[3] && value < scales[4]) {
            return colors[4];
        } else if (value >= scales[4] && value < scales[5]) {
            return colors[5];
        } else if (value >= scales[5] && value < scales[6]) {
            return colors[6];
        } else if (value >= scales[6] && value < scales[7]) {
            return colors[7];
        } else if (value >= scales[7] && value < scales[8]) {
            return colors[8];
        } else if (value >= scales[8] && value < scales[9]) {
            return colors[9];
        } else {
            return colors[10];
        }
    }

    addGeoJsonMouseOverListener(geoJsonObject) {
        let self = this;
        geoJsonObject.addListener('mouseover', function(evt) {
            let tooltipInfo =
                evt.feature.getProperty('veh_description') +
                '<br> <b>' +
                evt.feature.getProperty('start') +
                ' - ' +
                evt.feature.getProperty('end') +
                '<br><a target="_blank" href="' +
                evt.feature.getProperty('veh_path') +
                '">Ver en Travel</a></b>';
            if (tooltipInfo !== '') {
                let infowindow = self.getInfowindow(tooltipInfo, true);
                infowindow.setPosition(evt.latLng);
                self.activeInfoWindows.push(infowindow);
                geoJsonObject.overrideStyle(evt.feature, {
                    strokeWeight: 3
                });
                infowindow.open(self.googleMap);
            }
        });
    }

    addGeoJsonMouseOutListener(geoJsonObject) {
        let self = this;
        geoJsonObject.addListener('mouseout', function(evt) {
            self.activeInfoWindows.forEach(info => {
                info.setMap(null);
            });
            geoJsonObject.overrideStyle(evt.feature, {
                strokeWeight: 2
            });
            self.activeInfoWindows = [];
        });
    }

    addGeoJsonClickListener(geoJsonObject) {
        let self = this;
        geoJsonObject.addListener('click', function(evt) {
            self.polylineClicked(evt.feature);
        });
    }

    showTravel(geojson, vehiclesList) {
        if (this.geojsonTravel) {
            this.geojsonTravel.setMap(this.googleMap);
        } else {
            let geoData = new google.maps.Data();
            geoData.addGeoJson(geojson, {
                idPropertyName: 'customId'
            });
            geoData.toGeoJson(function(geojson) {
                let allFeatures = geojson['features'];
                for (let i = 0; i < allFeatures.length; i++) {
                    let currentFeature = allFeatures[i];
                    let featureObject = geoData.getFeatureById(currentFeature['properties']['customId']) as google.maps.Data.Feature;
                    let indexFeatureInVehiclesList = vehiclesList.findIndex(
                        vehicle => vehicle['id'] === currentFeature['properties']['vehicle']
                    );
                    if (indexFeatureInVehiclesList !== -1) {
                        featureObject.setProperty('strokeColor', vehiclesList[indexFeatureInVehiclesList]['color']);
                    }
                }
            });

            this.setGeoJsonStyles(geoData);
            this.addGeoJsonMouseOverListener(geoData);
            this.addGeoJsonMouseOutListener(geoData);
            this.addGeoJsonClickListener(geoData);
            this.geojsonTravel = geoData;
            this.geojsonTravel.setMap(this.googleMap);
        }
    }

    showSegmentsOfWork(geojson) {
        if (this.geojsonSegmentsOfWork) {
            this.geojsonSegmentsOfWork.setMap(this.googleMap);
        } else {
            let geoData = new google.maps.Data();
            geoData.addGeoJson(geojson, {
                idPropertyName: 'customId'
            });
            this.setGeoJsonStyles(geoData);
            this.addGeoJsonMouseOverListener(geoData);
            this.addGeoJsonMouseOutListener(geoData);
            this.addGeoJsonClickListener(geoData);
            this.geojsonSegmentsOfWork = geoData;
            this.geojsonSegmentsOfWork.setMap(this.googleMap);
        }
    }

    /* Pasadas de Calibracion */
    async toggleCalibrationPassesFromMap(calibrationsToShow: CalibrationsPassesMap){
        /* Muestro/Oculto calibraciones en base a los checkbox Aplicadas y No Aplicadas */
        let self = this;
        if(this.allCalibrationsPasses){
            let originalDataLayer: google.maps.Data = this.allCalibrationsPasses;
            let filteredFeatures: Array<google.maps.Data.Feature> = [];
            let showActivePasses = calibrationsToShow.actives; //boolean
            let showInactivePases = calibrationsToShow.inactives; //boolean

            // Recorrer el geojson original y generar uno nuevo en base a los filtros
            //aplicadas y no aplicadas
            await originalDataLayer.toGeoJson(function(geojson) {
                let allFeatures = geojson['features'];
                    allFeatures.forEach(feature => {
                        let currentCalibrationIsActive = feature['properties']['active_calibration_pass']

                        //si "Aplicadas" esta activo
                        //pusheo las features que estan aplicadas
                        if(showActivePasses && currentCalibrationIsActive){
                            filteredFeatures.push(feature);
                        }

                        //si NO "Aplicadas" esta activo
                        //pusheo las features que estan NO aplicadas
                        if(showInactivePases && !currentCalibrationIsActive){
                            filteredFeatures.push(feature);
                        }
                    });
            })
            //muestro las pasadas filtradas
            // objeto GeoJSON feature collection
            this.showCalibrationPasses({
                type: 'FeatureCollection',
                features: filteredFeatures
            });
        }
    }

    saveAllCalibrations(geojson:CalibrationsPassesGeojson){
        this.allCalibrationsPasses = this.getCalibrationsDataLayer(geojson);
    }

    showCalibrationPasses(geojson: CalibrationsPassesGeojson) {
        this.showCalibrationsPassesToggle = true;
        this.hideCalibrationPasses();
        this.geojsonCalibrationPasses = this.getCalibrationsDataLayer(geojson);
        this.geojsonCalibrationPasses.setMap(this.googleMap);
    }

    getCalibrationsDataLayer(geojson: CalibrationsPassesGeojson): google.maps.Data{
        let geoData = new google.maps.Data();
        geoData.addGeoJson(geojson, {
            idPropertyName: 'customId'
        });
        if(geojson.features.length > 0){
            this.setGeoJsonStyles(geoData);
            this.addGeoJsonMouseOverListener(geoData);
            this.addGeoJsonMouseOutListener(geoData);
            this.addGeoJsonClickListener(geoData);
        }
        return geoData;
    }

    hideCalibrationsCheckbox(){
        this.showCalibrationsPassesToggle = false;
    }

    hideCalibrationPasses() {
        if (this.geojsonCalibrationPasses) {
            this.geojsonCalibrationPasses.setMap(null);
        }
    }
    //---------- /* Pasadas de Calibracion */ ----------------

    hideSegmentsOfWork() {
        if (this.geojsonSegmentsOfWork) {
            this.geojsonSegmentsOfWork.setMap(null);
        }
        this.geojsonSegmentsOfWork = null;
    }

    hideTravel() {
        if (this.geojsonTravel) {
            this.geojsonTravel.setMap(null);
        }
        this.geojsonTravel = null;
    }

    hideGroundOverlaysFromMap() {
        this.visibleGroundOverlays.forEach(point => {
            point.setMap(null);
        });
        this.visibleGroundOverlays = [];
    }

    changeOpacityGroundOverlay(groundOverlay: google.maps.GroundOverlay, opacity: number, url?: string) {
        let objectOverlay = groundOverlay;
        if (url) {
            let indexUrl = this.getIndexVisibleGroundOverlay(url);
            if (indexUrl !== -1) {
                objectOverlay = this.visibleGroundOverlays[indexUrl];
            }
        }
        groundOverlay.setOpacity(opacity);
    }

    hideGroundOverlayFromMap(url) {
        let indexUrl = this.getIndexVisibleGroundOverlay(url);
        if (indexUrl !== -1) {
            this.visibleGroundOverlays[indexUrl].setMap(null);
            this.visibleGroundOverlays.splice(indexUrl, 1);
        }
    }

    getIndexVisibleGroundOverlay(url) {
        let indexGroundOverlay = this.visibleGroundOverlays.findIndex(item => item['url'] === url);
        return indexGroundOverlay;
    }

    setGroundOverlayInMap(imageUrl, imageBounds, centerVisualization?) {
      
        let self = this;
        let indexUrl = this.getIndexVisibleGroundOverlay(imageUrl);

        
        let groundOverlay = new google.maps.GroundOverlay(imageUrl, imageBounds, {
            opacity: 1
        });
        this.visibleGroundOverlays.push(groundOverlay);
        groundOverlay.setMap(self.googleMap);
        google.maps.event.addListener(groundOverlay, 'click', event => {
            self.smartRouteStartPoint = event.latLng.toJSON();
            self.groundOverlayClicked(event.latLng.toJSON());
        });
        if (centerVisualization) {
            this.setCenter(imageBounds);
        }
    }

    @Emit()
    groundOverlayClicked(latLng){}



    getReducedPoints(listOfPoints, topic: string) {
        let pointsLenght = listOfPoints.length;
        if (pointsLenght > this.maxLimitOfPointsToShow) {
            let reducedPercent: number = this.calculePercentToShow(pointsLenght);
            listOfPoints = listOfPoints.splice(0, this.maxLimitOfPointsToShow);
            this.$_showEmptyLastReport('Se están visualizando un ' + reducedPercent + '% de los puntos de ' + topic);
        }
        return listOfPoints;
    }

    calculePercentToShow(listLength: number) {
        return Math.round((100 * this.maxLimitOfPointsToShow) / listLength);
    }

    showHumidityMap(list, scales) {
        let self = this;

        if (this.visibleHumidityCircles.length > 0) {
            this.visibleHumidityCircles.forEach(point => {
                point.setVisible(true);
            });
        } else {
            this.visibleHumidityCircles = [];
            for (let index = 0; index < list.length; index++) {
                const line = list[index];
                let points = this.getReducedPoints(line['vehicle_data'], 'Humedad');

                points.forEach(d => {
                    let point = {
                        lat: d.gps_latitude,
                        lng: d.gps_longitude,
                        performance: d.performance,
                        work_width: d.work_width
                    };
                    let circle = self.createCircle(point, scales);
                    circle.setMap(self.googleMap);
                    self.visibleHumidityCircles.push(circle);
                });
            }
        }
    }

    hideHumidityMap() {
        this.visibleHumidityCircles.forEach(point => {
            point.setVisible(false);
        });
    }

    hidePolylines() {
        if (this.visiblePolylines.length > 0) {
            for (let index = 0; index < this.visiblePolylines.length; index++) {
                const poly = this.visiblePolylines[index];
                poly.setMap(null);
            }
        }
    }

    setCenter(bounds: google.maps.LatLngBounds) {
        if(!bounds || !this.googleMap){
            return
        }

        this.googleMap.setCenter(bounds.getCenter());
    }

    setZoom(zoom: number) {
        this.googleMap.setZoom(zoom);
    }

    fitBounds(bounds: google.maps.LatLngBounds) {
        if(!bounds || !this.googleMap){
            return
        }
        this.googleMap.fitBounds(bounds);
    }

    removeGeoJsonFeatures() {
        if(this.googleMap && this.googleMap.data){
            this.googleMap.data.forEach(feature => {
                this.googleMap.data.remove(feature);
            })
        }
    }

    mounted() {
        this.addCtrlListeners();
        let self = this;
        this.$nextTick(() => {
            self.addMapListeners();
            self.$emit('map-is-visible');
        });
    }

    divideSelectedFeature(feature: google.maps.Data.Feature) {
        this.featureIdToIntersect = feature.getProperty('ranch_id') as number;
        this.enableMapDrawingTools();
    }

    addNewPolygon(){
        // console.log("addNewPolygon");
        this.enableMapDrawingTools();
    }

    enableMapDrawingTools() {
        //aca
        let self = this;
        let polygonType: any = ['POLYGON'];
        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: polygonType
            }
        });
        this.drawingManager.setMap(this.googleMap);

        // document.addEventListener('keydown', function(event) {
        //     if (event.code === 'Escape') {
        //         self.removeDrawingTools();
        //     }
        // });

        google.maps.event.addListener(this.drawingManager, 'polygoncomplete', function(newPolygon: google.maps.Polygon) {
            self.polyCoords = [];
            self.addCoordsToFeature(newPolygon);
            newPolygon.setMap(null);
            self.waitForSavePoly();
        });
    }

    waitForSavePoly() {
        this.visibilityAddPolygonModal(true);
    }

    removeDrawingTools() {
        let self = this;
        if(this.drawingManager !== null){
            this.drawingManager.setDrawingMode(null);
            this.drawingManager.setMap(null);
        }

        if(
            this.previousEditableFeature 
        ){
            
           let previousId = this.previousEditableFeature.getProperty('customId');
           let geometriesToExclude = this.previousEditableFeature.getGeometry();
           this.googleMap.data.forEach(feature => {

                if(feature.getProperty('customId') === previousId){
                    // console.log("remuevo feature", feature);
                    self.googleMap.data.remove(feature);
                }
           });
           this.previousEditableFeature = null;
           this.previousFeatureCoords.coords = null;
        }
    }

    undoPolygonChange() {}


   

    cancelEditPolygon() {
        if(!this.editPolygon){
            return
        }
        this.currentPoly = [];
        this.rollbackFeatureChanges();
        this.editPolygon = false;
    }

    rollbackFeatureChanges() {
        let self = this;
        if(!this.editPolygon){
            return
        }
        
        if ( this.previousEditableFeature !== null && this.previousFeatureCoords.coords) {
            
            let previousId = this.previousEditableFeature.getProperty('customId')
            let previousCoords = this.previousFeatureCoords.coords;
            this.googleMap.data.forEach(feature => {
               if(feature.getProperty('customId') === previousId){
                   self.googleMap.data.overrideStyle(feature, { visible: true, editable: false });
                   feature.setGeometry(previousCoords);
               }
            });
            this.previousEditableFeature = null;
            this.previousFeatureCoords.coords = null;
        }
        
    }

    cancelPolygon() {
        this.cancelEditPolygon();
        this.removeDrawingTools();
        this.visibilityAddPolygonModal(false);
        this.rollbackFeatureChanges();

    }

    onSavePolygon(polyName: string, cropTypeSelected:object | null) {
        this.visibilityAddPolygonModal(false);
        this.savePolygon(polyName, cropTypeSelected);
        this.cancelEditPolygon();
        this.removeDrawingTools();
    }


    savePolygon(polyName: string, cropTypeSelected:object | null ) {
        // console.log("coords to intersect", this.polyCoords);
        // console.log("ranch id", this.featureIdToIntersect);
        // console.log("saved polygons on memory", this.savedPolygonsOnMemory);
        let {coords, type} = this.getCoordsFromCurrentEditablePolygon();
        let featureType = type;
        let isNewFeature = this.previousEditableFeature && this.previousEditableFeature.getProperty('newPolygon');

        

        if(this.featureIdToIntersect !== -1){
            //intersectar chacras
            let parsedCoords:google.maps.LatLng[] =  convertCoordinatesToLatLng(coords);
            this.intersectRanch(this.featureIdToIntersect, parsedCoords, polyName);
            // console.log("intersecto chacras");
            return
        }

        if (this.previousEditableFeature) {
            //when edit a previous feature
            //need to add new polygons from savedPolygonsOnMemory to the feature
            if(isNewFeature){
                // console.log("agrego poligono")
                this.newGeojson(polyName, coords, featureType);
            }else{
                let {coords, type} = this.getCoordsFromCurrentEditablePolygon();
                // console.log("edito poligono")
                this.modifyRanchPolygon(
                    polyName, 
                    cropTypeSelected, 
                    coords,
                    type,
                    this.previousEditableFeature
                );
            }
        }

    }

    @Emit()
    newGeojson(polyName, newMulti, type){}

    setMarkers(markers: any) {
        this.clean();
        this.markersPositions = this.getGoogleMarkers(markers);
        this.addInfoToAllMarkers(this.markersPositions);
        let bounds = new google.maps.LatLngBounds();
        for (let index = 0; index < this.markersPositions.length; index++) {
            const marker = this.markersPositions[index];
            bounds.extend(marker['marker'].position);
        }

        // console.log("bounds from markers", bounds);
        this.setCenter(bounds);
        this.fitBounds(bounds);
        // this.addInfoToAllMarkers(this.travelPositions, true);
    }

    getGoogleMarkers(markers) {
        let self = this;
        let result: any = [];

        markers.forEach((marker, index) => {
            let markerColor:string = marker['type'] === 'sowing' ? 'rgba(21, 101, 192, 0.98)' : 'rgba(26, 241, 123, 0.98)';
            let markerToPush = new google.maps.marker.AdvancedMarkerElement({
                position: {
                    lng: marker['position']['longitude'],
                    lat: marker['position']['latitude']
                },
                content: customPinElement({
                    backgroundColor: markerColor,
                }),
                zIndex: 20
            });
            result.push({
                marker: markerToPush,
                value: marker
            });
            result[index].marker.setMap(this.googleMap);
        });
        return result;
    }

    addInfoToAllMarkers(googleMarkers: any, ignoreInToFirstMarker?: boolean): void {
        for (let i = 0; i < googleMarkers.length; i++) {
            this.addInfoToMarkers(googleMarkers[i].marker, googleMarkers[i].value);
        }
    }

    showInfoToMarker(marker: any, markerApp: Marker) {
        let self = this;
        let contentInfoWindow = getContentInfoVehicleInsurance(markerApp);
        if (contentInfoWindow !== '') {
            let infowindow = self.getInfowindow(contentInfoWindow);
            infowindow.open(this.googleMap, marker);
            this.markersInfoWindows.push(infowindow);
        }
    }

    getCoordsFromPolygon(polygon: google.maps.Polygon): Array<{ lat: number; lng: number }> {
        let coordinates: Array<{
            lat: number;
            lng: number;
        }> = [];
        let path = polygon.getPath().getLength();
        for (let i = 0; i < path; i++) {
            coordinates.push({
                lat: polygon
                    .getPath()
                    .getAt(i)
                    .lat(),
                lng: polygon
                    .getPath()
                    .getAt(i)
                    .lng()
            });
        }
        return coordinates;
    }

    addMarkerToMap(marker: google.maps.marker.AdvancedMarkerElement) {
        let self = this;
        marker.map = this.googleMap;

        marker.addListener('dragend', event => {
            //need to modify this
            let markerType = marker['type'];
            let markerId = marker['id'];
            self.draggedMarker(event.latLng.toJSON(), markerType, markerId);
        });
        this.visibleMarkers.push(marker);
    }

    @Emit()
    saveSmartRoute(){
        this.closeModalSmartRoute();
    }

    @Emit()
    draggedMarker(latLng, markerType, markerId){
        if(markerType === 'smart_start_point'){
            this.smartRouteStartPoint = latLng;
        }
    }

    setMarkersOnMap(markers: Array<google.maps.marker.AdvancedMarkerElement>){
        markers.forEach(marker => {
            this.addMarkerToMap(marker);
        });
    }

    removeMarkersFromMap(){
        this.visibleMarkers.forEach(marker => {
            marker.map = null;
        });
        this.visibleMarkers = [];
    }

    getInfowindow(value, noPixelOffset?: boolean) {
        let pixelOff = noPixelOffset ? null : new google.maps.Size(0, -20)
        return getInfoWindow(value, undefined, pixelOff)
    }

    addInfoToMarkers(marker: any, value: any) {
        // console.log("marker value", value);
        let self = this;
        let contentInfo = getContentInfoVehicleInsurance(value);
        // console.log("contentInfo", contentInfo);
        if (contentInfo !== '') {
            let infowindow = self.getInfowindow(getContentInfoVehicleInsurance(value));
            // console.log("contentInfo", contentInfo);
            attachMarkerListeners(marker, infowindow)
            this.markersInfoWindows.push(infowindow);
        }
    }

    clearMarkers() {
        this.markersPositions.forEach(marker => {
            marker['marker'].map = null;
        });
    }

    cleanInfoWindows() {
        if (this.markersInfoWindows) {
            this.markersInfoWindows.forEach(info => {
                info.close();
                info = null;
            });
            this.markersInfoWindows = [];
        }
    }

    editFeatureById(customIdToEdit: any) {
        let featureToEdit: google.maps.Data.Feature = this.getFeatureById(customIdToEdit);
        this.triggerEvent('mouseout', {
            feature: featureToEdit
        });
        this.modifyPolygon(featureToEdit);
        // console.log('feature to edit', featureToEdit);
    }

    exportSelectedRanchs() {
        this.$emit('selected-ranchs', this.selectedRanchs);
    }

    @Destroyed
    clean(): void {
        // console.log("destroy map");
        this.clearMarkers();
        this.cleanInfoWindows();
        this.hideGroundOverlaysFromMap();
        this.exportSelectedRanchs();
    }
}
